export default "<div class=\"query-suggestions\">\n    <p>Did you mean to search for {{query-suggestions querySuggestions}}?</p>\n</div>";